import script from "./AttendeeEditModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AttendeeEditModal.vue?vue&type=script&setup=true&lang=js"

import "./AttendeeEditModal.vue?vue&type=style&index=0&id=4c7598a1&lang=css"

const __exports__ = script;

export default __exports__